import React from 'react'

import type { StatsData } from '../../../../../analyticsModule/components/AnalyticsCard/AnalyticsCard.types'
import { useAnalyticsCardBase } from '../../../../../hooks/useAnalyticsCardBase'
import type { StatsReportCardProps } from '../../../AnalyticsDashboard.types'
import { ConversionRateReportCardLabel } from './components/ConversionRateReportCardLabel'
import { calculatePercentage } from './utils/calculatePercentage'

const reportId = 'conversion_rates'

type ConversionRateSummaryRow = {
  cart_created_count: number
  checkout_created_count: number
  checkout_paid_count: number
  total_sessions: number
}

export const useConversionRateReportCard = (): StatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({ reportId })
  const summaryData = analyticsCardBase.reportData?.report?.summary as
    | ConversionRateSummaryRow
    | undefined

  const data: StatsData[] = summaryData
    ? [
        {
          label: (
            <ConversionRateReportCardLabel
              label="Added to cart"
              sessionsNumber={summaryData?.cart_created_count || 0}
            />
          ),
          value: calculatePercentage(
            summaryData?.cart_created_count || 0,
            summaryData?.total_sessions || 0,
          ),
        },
        {
          label: (
            <ConversionRateReportCardLabel
              label="Checkout started"
              sessionsNumber={summaryData?.checkout_created_count || 0}
            />
          ),
          value: calculatePercentage(
            summaryData?.checkout_created_count || 0,
            summaryData?.total_sessions || 0,
          ),
        },
        {
          label: (
            <ConversionRateReportCardLabel
              label="Successful checkout"
              sessionsNumber={summaryData?.checkout_paid_count || 0}
            />
          ),
          value: calculatePercentage(
            summaryData?.checkout_paid_count || 0,
            summaryData?.total_sessions || 0,
          ),
        },
      ]
    : []

  return {
    ...analyticsCardBase,
    value: calculatePercentage(
      summaryData?.checkout_paid_count || 0,
      summaryData?.total_sessions || 0,
    ),
    formatValue: (value) => `${value}%`,
    legend: undefined,
    type: 'stats',
    data,
    header: {
      ...analyticsCardBase.header,
      label: 'Conversion rate',
    },
  }
}
